import { render, staticRenderFns } from "./CompareHeadlinePane.vue?vue&type=template&id=af8820aa&"
import script from "./CompareHeadlinePane.vue?vue&type=script&lang=js&"
export * from "./CompareHeadlinePane.vue?vue&type=script&lang=js&"
import style0 from "./CompareHeadlinePane.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports